export default __webpack_public_path__ + "static/media/apiary.990898e7.svg";